<template>
  <DetailTemplate
    :customClass="'project-detail detail-page'"
    v-if="getPermission('project:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div class="d-flex px-0 flex-wrap align-center">
          <!-- <Status :status="customerActivated"></Status> -->
          <template v-if="projectArr && projectArr.status">
            <span class="my-1">
              <v-chip
                :color="getColor(projectArr.status)"
                label
                v-if="projectArr.status"
                class="ml-2 mr-2"
              >
                <span class="font-size-16 font-weight-500">
                  {{ getStatus(projectArr.status) }}
                </span>
              </v-chip>
              <CustomStatus
                v-if="false"
                :status="projectArr.status"
                endpoint="project/status"
              ></CustomStatus>
            </span>

            <template v-if="projectArr.project_type">
              <v-chip
                label
                :color="
                  projectArr.project_type == 'comprehensive' ? 'green' : 'red'
                "
                text-color="white"
                class="text-capitalize"
              >
                {{ projectArr.project_type }}
              </v-chip>
            </template>
            <template v-else
              ><em class="text-muted">No Project Type</em></template
            >
          </template>
          <v-chip
            v-if="projectArr?.is_signed == 1"
            label
            class="ml-2"
            color="red darken-3"
            text-color="white"
          >
            Sent
          </v-chip>
        </div>

        <!--    <div>
          <span
            class="font-weight-bold color-custom-blue font-size-21 ml-2 my-1"
            >{{ formatMoney(projectArr.total) }}</span
          >
        </div> -->
        <div class="mt-5 px-0">
          <table width="100%">
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Project Information
              </th>
            </tr>
            <tr>
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500"
                colspan="2"
              >
                Date
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18" colspan="2">
                <div class="d-flex align-center">
                  <div>
                    <date-picker
                      v-if="poEditMode"
                      key="date"
                      id="date"
                      placeholder="Date"
                      v-model="projectArr.date"
                    />
                    <template v-else>
                      <template v-if="projectArr?.date">
                        {{ formatDate(projectArr.date) }}</template
                      >
                      <em v-else class="text-muted">no date</em>
                    </template>
                  </div>
                  <div class="d-flex align-center">
                    <template v-if="poEditMode">
                      <v-btn
                        @click="updateProjectStatus(0)"
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        class="ml-2"
                        icon
                        depressed
                        small
                        color="green"
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                      <v-btn
                        class="ml-2"
                        @click="poEditMode = false"
                        icon
                        depressed
                        small
                        color="red"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>

                    <v-btn
                      v-else
                      class="ml-2"
                      @click="poEditMode = true"
                      icon
                      depressed
                      small
                      color="cyan"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500"
                width="130"
              >
                Project #
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <v-chip
                  label
                  color="chip-custom-blue"
                  outlined
                  class="text-white p-3"
                  small
                  >{{ projectArr?.barcode }}
                </v-chip>
              </td>
            </tr>

            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Reference #
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0" v-if="projectArr.reference">{{
                  projectArr.reference
                }}</label>
                <em class="text-muted" v-else> no reference</em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Project Duration
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 text-capitalize font-weight-600"
              >
                <b>
                  ({{ projectArr.project_duration }}
                  {{ getRename(projectArr.project_frequency) }})</b
                >
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Start Date
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <template v-if="projectArr.started_at">{{
                  formatDate(projectArr.started_at)
                }}</template>
                <template v-else
                  ><em class="text-muted">Not Start Date</em></template
                >
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                End Date
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <template v-if="projectArr.deadline">{{
                  formatDate(projectArr.deadline)
                }}</template>
                <template v-else
                  ><em class="text-muted">No End Date</em></template
                >
              </td>
            </tr>
            <tr>
              <td valign="top" class="py-1 font-size-18 font-weight-500">
                Commencement Date
              </td>
              <td valign="top" class="py-1 font-size-18">
                <template v-if="projectArr.commencement_date">{{
                  formatDate(projectArr.commencement_date)
                }}</template>
                <template v-else
                  ><em class="text-muted">No Commencement Date</em></template
                >
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Billing Frequency
              </td>
              <td valign="middle" class="py-1 font-size-18 text-capitalize">
                <template v-if="projectArr.frequency"
                  ><b>
                    {{ projectArr.frequency }}
                  </b></template
                >
                <template v-else
                  ><em class="text-muted">No Billing Frequency</em></template
                >
              </td>
            </tr>
            <tr>
              <td
                valign="top"
                class="py-1 font-size-18 font-weight-500 text-capitalize"
              >
                Contract Period Frequency
              </td>
              <td valign="top" class="py-1 font-size-18 text-capitalize">
                <b>{{ getRename(projectArr.contract_frequency) }}</b>
              </td>
            </tr>
            <tr>
              <td
                valign="top"
                class="py-1 font-size-18 font-weight-500 text-capitalize"
              >
                Contract No. Of {{ getRename(projectArr.contract_frequency) }}
              </td>
              <td valign="top" class="py-1 font-size-18">
                <div>
                  <v-avatar
                    size="28"
                    color="blue"
                    class="white--text d-flex justify-center align-center"
                  >
                    <span class="text-center" style="font-size: 12px">
                      {{ projectArr.contract_years }}
                    </span>
                  </v-avatar>
                </div>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Payable Duration
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <template v-if="projectArr.payable_duration"
                  ><b>{{ projectArr.payable_duration }}</b></template
                >
                <template v-else
                  ><em class="text-muted">No Payable Duration</em></template
                >
              </td>
            </tr>
            <br />
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1 mt-2"
              >
                Project Costing
              </th>
            </tr>

            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Value
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <span
                  class="text--uppercase pr-2 font-weight-600"
                  v-if="projectArr && projectArr.project_value"
                  >{{ formatMoney(projectArr.project_value) }}</span
                >
                <em v-else class="text-muted"> no Project Value</em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Budget
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <span
                  class="text--uppercase pr-2"
                  v-if="projectArr && projectArr.project_budget"
                  ><b>{{ formatMoney(projectArr.project_budget) }}</b></span
                >
                <em v-else class="text--secondary"> no Project Budget</em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Customer Purchase Order
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <span
                  class="text--uppercase pr-2"
                  v-if="projectArr.customer_purchase_order"
                  >{{ projectArr.customer_purchase_order }}</span
                >
                <em v-else class="text-muted"> no Customer Purchase Order</em>
              </td>
            </tr>

            <template v-if="projectArr.is_optional_period > 0">
              <br />
              <tr>
                <th
                  colspan="2"
                  class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1 mt-2"
                >
                  Optional Period
                </th>
              </tr>

              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Duration
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 text-capitalize font-weight-600"
                >
                  <b>
                    ({{ projectArr.optional_period_duration }}
                    {{ getRename(projectArr.optional_period_frequency) }})</b
                  >
                </td>
              </tr>
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Start Date
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <template v-if="projectArr.optional_period_date">{{
                    formatDate(projectArr.optional_period_date)
                  }}</template>
                  <template v-else
                    ><em class="text-muted">Not Start Date</em></template
                  >
                </td>
              </tr>
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  End Date
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <template v-if="projectArr.optional_period_end_date">{{
                    formatDate(projectArr.optional_period_end_date)
                  }}</template>
                  <template v-else
                    ><em class="text-muted">No End Date</em></template
                  >
                </td>
              </tr>
            </template>
          </table>
        </div>
      </v-card>
    </template>
    <template v-slot:header-title>
      <div class="d-flex">
        <template v-if="pageLoading">
          <v-skeleton-loader
            class="custom-skeleton"
            width="400"
            height="28"
            type="text"
          >
          </v-skeleton-loader>
          <v-skeleton-loader
            class="custom-skeleton height-30px my-auto mx-2 custom-skeleton-full-width"
            width="130"
            type="text"
          >
          </v-skeleton-loader>
        </template>
        <template v-else>
          <h1 class="form-title custom-nowrap-ellipsis text-capitalize">
            {{ projectArr?.name }}
          </h1>
        </template>
      </div>
    </template>
    <template v-slot:header-action>
      <template v-if="getPermission('project:update')">
        <template v-if="projectArr.status < 4">
          <v-tooltip top content-class="custom-top-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="pageLoading"
                class="mx-2 custom-bold-button white--text"
                color="cyan"
                v-bind="attrs"
                v-on="on"
                v-on:click="updateProject()"
              >
                <v-icon left>mdi-pencil</v-icon> Edit
              </v-btn>
            </template>
            <span>Click here to edit Project</span>
          </v-tooltip>
        </template>
        <v-menu
          style="z-index: 99 !important"
          transition="slide-y-transition"
          bottom
          content-class="custom-menu-list"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              :disabled="pageLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-bind="attrs"
              v-on="on"
            >
              More... <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <template v-for="(more, index) in projectMoreAction">
              <v-list-item
                link
                v-on:click="updateMoreAction(more.action)"
                :key="index"
                :disabled="more.disabled"
              >
                <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                  <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-500 font-size-14">{{
                  more.title
                }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <v-btn
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="goBack"
      >
        <v-icon small left>mdi-keyboard-backspace</v-icon>
        Back
      </v-btn>
    </template>
    <template v-slot:body>
      <v-tabs
        v-model="projectTab"
        background-color="transparent"
        color="cyan"
        class="custom-tab-transparent"
      >
        <template v-for="(tab, index) in tabs">
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            :key="index"
            :href="'#' + tab.key"
            :disabled="tab.disabled"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg
                :src="$assetURL('media/custom-svg/' + tab.key + '.svg')"
              />
              <!--end::Svg Icon-->
            </span>
            {{ tab.title }}
          </v-tab>
        </template>
      </v-tabs>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll"
        style="height: 84vh; position: relative"
      >
        <v-tabs-items v-model="projectTab">
          <v-tab-item v-if="getPermission('property:view')" :value="'property'">
            <v-container fluid>
              <v-card flat class="custom-grey-border remove-border-radius mb-4">
                <v-card-title class="headline grey lighten-4 py-1">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                    >Location Detail</span
                  >
                </v-card-title>
                <v-card-text class="p-6 font-size-16">
                  <span class="color-custom-blue font-weight-700 font-size-19">
                    <router-link
                      :to="
                        getDefaultRoute('customer.detail', {
                          params: {
                            id: projectArr?.customer_relation?.id,
                          },
                        })
                      "
                      >{{ projectArr?.customer_relation?.display_name }}
                    </router-link>
                  </span>
                  <v-layout class="my-4">
                    <v-flex md6 class="mr-2 custom-border-right">
                      <table width="100%">
                        <tr>
                          <td class="font-weight-600">
                            <span
                              class="font-weight-700 custom-headline color-custom-blue font-size-16"
                            >
                              Site Location</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td class="py-0 font-size-18 font-weight-500">
                            <template>
                              <div
                                class="custom-flex-d"
                                v-if="
                                  projectArr?.property_relation?.property_name
                                "
                              >
                                <b>
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    class="cmt-2"
                                  >
                                    mdi-home-map-marker
                                  </v-icon>
                                </b>
                                <span
                                  >{{
                                    projectArr?.property_relation
                                      ?.property_name
                                  }}<br
                                /></span>
                              </div>
                              <div v-else>
                                <em class="text-muted">
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    class="cmt-2"
                                  >
                                    mdi-home-map-marker
                                  </v-icon>
                                  no Site Name</em
                                >
                              </div>
                            </template>

                            <template>
                              <div class="custom-flex-d">
                                <b>
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    class="cmt-2"
                                  >
                                    mdi-map-marker
                                  </v-icon>
                                </b>
                                <span>
                                  <template
                                    v-if="
                                      projectArr?.property_relation?.unit_no
                                    "
                                    >{{
                                      projectArr?.property_relation?.unit_no
                                    }},</template
                                  >
                                  <template
                                    v-if="
                                      projectArr?.property_relation?.street_1
                                    "
                                    >{{
                                      projectArr?.property_relation?.street_1
                                    }},</template
                                  >
                                  {{ projectArr?.property_relation?.street_2 }}
                                  <br />
                                  {{ projectArr?.property_relation?.country }}
                                  <template
                                    v-if="
                                      projectArr?.property_relation?.zip_code &&
                                      projectArr?.property_relation?.zip_code !=
                                        '000000'
                                    "
                                  >
                                    {{
                                      projectArr?.property_relation?.zip_code
                                    }}
                                  </template>
                                </span>
                              </div>
                            </template>

                            <!--  <a v-if="projectArr &&
                                projectArr.property &&
                                projectArr.property.property_address
                                " target="_blank"
                                                          :href="`https://maps.google.com/?q=${projectArr.property.property_address}`">{{
                                projectArr.property.property_address }}</a> -->
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="font-weight-700 custom-headline color-custom-blue font-size-16"
                          >
                            Contact Details
                          </td>
                        </tr>
                        <tr
                          v-if="
                            projectArr.property_contact_person_relation &&
                            projectArr.property_contact_person_relation
                              ?.display_name
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              projectArr.property_contact_person_relation
                                .display_name
                            }}
                          </td>
                        </tr>
                        <tr
                          v-if="
                            projectArr.property_contact_person_relation &&
                            projectArr.property_contact_person_relation
                              .primary_phone
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              projectArr.property_contact_person_relation
                                .primary_phone
                            }}
                          </td>
                        </tr>
                        <tr v-else class="py-0 font-size-18 font-weight-500">
                          <em class="text-muted ml-2"> no phone number</em>
                        </tr>
                        <tr
                          v-if="
                            projectArr.property_contact_person_relation &&
                            projectArr.property_contact_person_relation
                              .primary_email
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              projectArr.property_contact_person_relation
                                .primary_email
                            }}
                          </td>
                        </tr>
                        <tr v-else class="py-0 font-size-18 font-weight-500">
                          <em class="text-muted ml-2"> no email address</em>
                        </tr>
                      </table>
                    </v-flex>
                    <v-flex md6 class="ml-2">
                      <table width="100%">
                        <tr>
                          <td class="font-weight-600">
                            <span
                              class="font-weight-700 custom-headline color-custom-blue font-size-16"
                            >
                              Billing Address</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td class="py-0 font-size-18 font-weight-500">
                            <template>
                              <div
                                class="custom-flex-d"
                                v-if="
                                  projectArr?.billing_relation?.property_name
                                "
                              >
                                <b>
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    class="cmt-2"
                                  >
                                    mdi-home-map-marker
                                  </v-icon>
                                </b>
                                <span
                                  >{{
                                    projectArr?.billing_relation?.property_name
                                  }}<br
                                /></span>
                              </div>
                              <div v-else>
                                <em class="text-muted">
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    class="cmt-2"
                                  >
                                    mdi-home-map-marker
                                  </v-icon>
                                  no Site Name</em
                                >
                              </div>
                            </template>

                            <template>
                              <div class="custom-flex-d">
                                <b>
                                  <v-icon
                                    style="
                                      font-size: 18px;
                                      margin-top: -3px !important;
                                    "
                                    class="cmt-2"
                                  >
                                    mdi-map-marker
                                  </v-icon>
                                </b>
                                <span>
                                  <template
                                    v-if="projectArr?.billing_relation?.unit_no"
                                    >{{
                                      projectArr?.billing_relation?.unit_no
                                    }},</template
                                  >
                                  <template
                                    v-if="
                                      projectArr?.billing_relation?.street_1
                                    "
                                    >{{
                                      projectArr?.billing_relation?.street_1
                                    }},</template
                                  >
                                  {{ projectArr?.billing_relation?.street_2 }}
                                  <br />
                                  {{ projectArr?.billing_relation?.country }}
                                  <template
                                    v-if="
                                      projectArr?.billing_relation?.zip_code &&
                                      projectArr?.billing_relation?.zip_code !=
                                        '000000'
                                    "
                                  >
                                    {{ projectArr?.billing_relation?.zip_code }}
                                  </template>
                                </span>
                              </div>
                            </template>

                            <!--  <a v-if="projectArr &&
                            projectArr.billing_relation &&
                            projectArr.billing_relation.property_address
                            " target="_blank"
                                                      :href="`https://maps.google.com/?q=${projectArr.billing_relation.property_address}`">{{
                            projectArr.billing_relation.property_address }}</a> -->
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="font-weight-700 custom-headline color-custom-blue font-size-16"
                          >
                            Contact Details
                          </td>
                        </tr>
                        <tr
                          v-if="
                            projectArr.billing_contact_person_relation &&
                            projectArr.billing_contact_person_relation
                              .display_name
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              projectArr.billing_contact_person_relation
                                .display_name
                            }}
                          </td>
                        </tr>

                        <tr
                          v-if="
                            projectArr.billing_contact_person_relation &&
                            projectArr.billing_contact_person_relation
                              .primary_phone
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              projectArr.billing_contact_person_relation
                                .primary_phone
                            }}
                          </td>
                        </tr>
                        <tr v-else class="py-0 font-size-18 font-weight-500">
                          <em class="text-muted ml-2"> no phone number</em>
                        </tr>
                        <tr
                          v-if="
                            projectArr.billing_contact_person_relation &&
                            projectArr.billing_contact_person_relation
                              .primary_email
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              projectArr.billing_contact_person_relation
                                .primary_email
                            }}
                            <!-- <v-icon
                          v-if="detail.billing_contact_person_relation_notify"
                          v-tippy="{
                            arrow: true,
                            arrowType: 'round',
                            animation: 'fade',
                          }"
                          content="Notification was sent to given email"
                          color="green lighten-1"
                          >mdi-check</v-icon
                        > -->
                          </td>
                        </tr>
                        <tr v-else class="py-0 font-size-18 font-weight-500">
                          <em class="text-muted ml-2"> no email address</em>
                        </tr>
                      </table>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-row>
                <v-col>
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4"
                  >
                    <v-card-title class="headline grey lighten-4 py-1">
                      <span
                        class="font-weight-700 custom-headline color-custom-blue font-size-16"
                        >Technicians</span
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        v-on:click="memberDialog = true"
                        v-if="
                          getPermission('project:update') &&
                          projectArr.status < 4
                        "
                      >
                        <v-icon color="cyan">mdi-cog</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text class="p-6 font-size-16">
                      <v-list-item
                        v-for="(member, index) in projectArr.members"
                        :key="index"
                      >
                        <v-list-item-avatar>
                          <v-img
                            :lazy-src="$defaultProfileImage"
                            :src="$assetAPIURL(member.user.profile_logo)"
                          ></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-size-18">{{
                            member.user.full_name
                          }}</v-list-item-title>
                          <!--  <v-list-item-subtitle
                                      class="font-size-14 text-capitalize line-height-1-5"
                                      >total logged hours :
                                      {{ member.logged_hours }}</v-list-item-subtitle
                                    > -->
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-btn
                            icon
                            v-if="
                              getPermission('project:delete') &&
                              projectArr.status < 4
                            "
                            v-on:click="deleteMember(member)"
                          >
                            <v-icon color="red lighten-1">mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <div
                        v-if="projectArr?.members?.length <= 0"
                        class="custom"
                      >
                        <p
                          class="m-0 row-not-found text-center font-weight-500 font-size-16"
                        >
                          <img
                            :src="$assetURL('media/error/empty.png')"
                            class="row-not-found-image"
                          />
                          Uhh... There are no technicians at the moment.
                        </p>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4"
                  >
                    <v-card-title class="headline grey lighten-4 py-1">
                      <span
                        class="font-weight-700 custom-headline color-custom-blue font-size-16"
                        >Managers</span
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        v-on:click="managerDialog = true"
                        v-if="
                          getPermission('project:update') &&
                          projectArr.status < 4
                        "
                      >
                        <v-icon color="cyan">mdi-cog</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text class="p-6 font-size-16">
                      <v-list-item
                        v-for="(manager, index) in projectArr.managers"
                        :key="index"
                      >
                        <v-list-item-avatar>
                          <v-img
                            :lazy-src="$defaultProfileImage"
                            :src="$assetAPIURL(manager.user.profile_logo)"
                          ></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-size-18">{{
                            manager.user.full_name
                          }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            icon
                            v-if="
                              getPermission('project:delete') &&
                              projectArr.status < 4
                            "
                            v-on:click="deleteManager(manager)"
                          >
                            <v-icon color="red lighten-1">mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>

                      <div
                        v-if="projectArr?.managers?.length <= 0"
                        class="custom"
                      >
                        <p
                          class="m-0 row-not-found text-center font-weight-500 font-size-16"
                        >
                          <img
                            :src="$assetURL('media/error/empty.png')"
                            class="row-not-found-image"
                          />
                          Uhh... There are no managers at the moment.
                        </p>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-card flat class="custom-grey-border remove-border-radius mb-4">
                <v-card-title class="headline grey lighten-4 py-1">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue font-size-16"
                    >DESCRIPTION</span
                  >
                </v-card-title>
                <v-card-text class="p-6 font-size-16">
                  <div
                    class="w-100 custom-grey-border p-4"
                    v-if="projectArr && projectArr.description"
                  >
                    <read-more
                      class=""
                      v-if="projectArr && projectArr.description"
                      more-str="read more"
                      :text="
                        projectArr.description || '<em>No Description</em>'
                      "
                      link="#"
                      less-str="read less"
                      :max-chars="200"
                    >
                    </read-more>
                  </div>
                  <div v-else>
                    <em class="text-muted"> no description </em>
                  </div>
                </v-card-text>
              </v-card>
              <v-row>
                <v-col>
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4"
                  >
                    <v-card-title class="headline grey lighten-4 py-1">
                      <span
                        class="font-weight-700 custom-headline color-custom-blue font-size-16"
                        >TERMS &amp; CONDITIONS</span
                      >
                    </v-card-title>
                    <v-card-text class="p-6 font-size-16">
                      <!-- {{detail.quotation_type}} -->

                      <div class="w-100 custom-grey-border p-4 mb-2">
                        <v-card-text class="p-6 font-size-16">
                          <template v-if="projectArr.term_conditions">
                            <div v-html="projectArr.term_conditions"></div>
                          </template>
                          <em v-else class="text-muted">
                            No Terms &amp; Conditions</em
                          >

                          <!-- <read-more
                            class="mx-2 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                            more-str="read more"
                            :text="
                              projectArr.term_conditions ||
                              '<em>No Terms &amp; Conditions</em>'
                            "
                            link="#"
                            less-str="read less"
                            :max-chars="2000"
                          >
                          </read-more> -->
                        </v-card-text>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col v-if="projectArr?.project_type == 'comprehensive'">
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4"
                  >
                    <v-card-title class="headline grey lighten-4 py-1">
                      <span
                        class="font-weight-700 custom-headline color-custom-blue font-size-16"
                        >Schedule of Rate (SOR) for Lifts under
                        ComprehensiveMaintenance Contract</span
                      >
                    </v-card-title>
                    <v-card-text class="p-6 font-size-16">
                      <!-- {{detail.quotation_type}} -->

                      <div class="w-100 custom-grey-border p-4 mb-2">
                        <v-card-text class="p-6 font-size-16">
                          <template v-if="projectArr.sor">
                            <div v-html="projectArr.sor"></div>
                          </template>
                          <em v-else class="text-muted"> No SOR</em>

                          <!--  <read-more
                            class="mx-2 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                            more-str="read more"
                            :text="projectArr.sor || '<em>No SOR</em>'"
                            link="#"
                            less-str="read less"
                            :max-chars="2000"
                          >
                          </read-more> -->
                        </v-card-text>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('attachment:view')"
            value="attachment"
          >
            <AdditionalDocuments
              :type-id="projectArr.id"
              class="mx-4"
              type-text="Project Attachments"
              :type="111"
              :extensive="false"
            >
            </AdditionalDocuments>
            <!--     <Attachments
              :images="fileArr"
              :parent="projectArr && projectArr.id ? projectArr.id : 0"
              type="project"
              :isPageLoading="pageLoading"
            ></Attachments> -->
          </v-tab-item>
          <v-tab-item value="milestones">
            <Milestones
              :detail="projectArr"
              type="project"
              v-on:reloadData="refressData"
            ></Milestones>
          </v-tab-item>

          <v-tab-item value="line-item">
            <ProjectLineItem
              :contract-frequency="projectArr.contract_frequency"
              is-project
              :show-price="false"
              v-on:line-item="lengthCount"
              :discount-level="
                projectArr.discount_type == 2 ? 'line_item' : 'transaction'
              "
              :related-id="project"
              :related-type="8"
            />
            <div class="mt-0 pr-2 font-weight-600" v-if="false">
              <table width="100%">
                <tr>
                  <td width="66%" class="py-1"></td>
                  <td width="18%" align="right" class="py-1">Sub Total</td>
                  <td width="18%" align="right" class="py-1">
                    {{ formatMoney(projectArr.sub_total) }}
                  </td>
                </tr>
                <tr v-if="projectArr.discount_type == 1">
                  <td class="py-1"></td>
                  <td align="right" class="py-1">
                    Discount
                    <span v-if="projectArr.discount_value_type == 1"
                      >({{ formatMoney(projectArr.discount_value) }})</span
                    >
                    <span v-if="projectArr.discount_value_type == 2"
                      >({{ formatNumber(projectArr.discount_value) }}%)</span
                    >
                  </td>
                  <td align="right" class="py-1">
                    {{ formatMoney(projectArr.discount_amount) }}
                  </td>
                </tr>
                <tr v-if="projectArr.tax_applied">
                  <td class="py-1"></td>
                  <td class="py-1" align="right">
                    Tax [GST {{ projectArr.tax_value }}%]
                  </td>
                  <td class="py-1" align="right">
                    {{ formatMoney(projectArr.tax_amount) }}
                  </td>
                </tr>
                <tr>
                  <td class="py-1"></td>
                  <td class="py-1" align="right">Adjustment</td>
                  <td class="py-1" align="right">
                    {{ formatMoney(projectArr.adjustment) }}
                  </td>
                </tr>
                <tr class="font-size-19">
                  <td class="py-1"></td>
                  <td class="py-1" align="right">Grand Total</td>
                  <td
                    class="py-1 font-weight-bold color-custom-blue"
                    align="right"
                  >
                    {{ formatMoney(projectArr.total) }}
                  </td>
                </tr>
              </table>
            </div>
          </v-tab-item>
          <v-tab-item :value="'visit'">
            <VisitListingTemplate
              is-admin
              visit-type="all"
              :visit-status="0"
              detailRoute="visit.detail"
              internal
              :project-id="projectArr && projectArr.id ? projectArr.id : 0"
              :customer-id="
                projectArr && projectArr.customer && projectArr.customer.id
                  ? projectArr.customer.id
                  : 0
              "
            ></VisitListingTemplate>
          </v-tab-item>
          <v-tab-item v-if="getPermission('task:view')" value="task">
            <Tasks :detail="projectArr" type="project"></Tasks>
          </v-tab-item>
          <v-tab-item v-if="getPermission('task:view')" value="timesheet">
            <Timesheets :detail="projectArr" type="project"></Timesheets>
          </v-tab-item>
          <v-tab-item value="contract" v-if="getPermission('contract:view')">
            <Contracts :detail="projectArr" type="project"></Contracts>
          </v-tab-item>
          <v-tab-item :value="'costing'">
            <ProjectCostings
              :detail="projectArr"
              type="project"
            ></ProjectCostings>
          </v-tab-item>
          <v-tab-item v-if="getPermission('job:view')" :value="'job'">
            <Tickets :detail="projectArr" type="project"></Tickets>
          </v-tab-item>
          <v-tab-item v-if="getPermission('quotation:view')" value="quotation">
            <Quotations :detail="projectArr" type="project"></Quotations>
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('purchase-order:view')"
            value="purchase-order"
          >
            <PurchaseOrders
              :detail="projectArr"
              type="project"
            ></PurchaseOrders>
          </v-tab-item>
          <v-tab-item v-if="getPermission('invoice:view')" :value="'invoice'">
            <Invoices :detail="projectArr" type="project"></Invoices>
          </v-tab-item>
          <v-tab-item v-if="getPermission('history:view')" :value="'history'">
            <InternalHistoryDetail
              type="project"
              :type_id="projectArr && projectArr.id ? projectArr.id : 0"
            ></InternalHistoryDetail>
          </v-tab-item>
        </v-tabs-items>
      </perfect-scrollbar>
      <template v-if="getPermission('project:update') && memberDialog">
        <Dialog :commonDialog="memberDialog">
          <template v-slot:title>Technicians</template>
          <template v-slot:body>
            <v-container class="py-0">
              <v-row>
                <v-col md="12" class="py-0">
                  <v-autocomplete
                    dense
                    color="cyan"
                    filled
                    :items="memberList"
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    v-model.trim="members"
                    label="Technicians"
                    solo
                    flat
                    item-color="cyan"
                    item-text="full_name"
                    item-value="id"
                    hide-details
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 3">
                        <span>{{ item.full_name }}</span>
                      </v-chip>
                      <span v-if="index === 3" class="grey--text font-size-12">
                        <template v-if="members && members.length"
                          >(+{{ members.length - 3 }} others)</template
                        >
                      </span>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No Member Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template v-slot:action>
            <v-container class="py-0">
              <v-row>
                <v-col md="12" class="text-right">
                  <v-btn
                    depressed
                    v-on:click="memberDialog = false"
                    :disabled="pageLoading"
                    class="mx-2 custom-grey-border custom-bold-button"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    depressed
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    class="mx-2 custom-bold-button white--text"
                    v-on:click="updateMembers"
                    color="cyan"
                  >
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </Dialog>
      </template>

      <template v-if="getPermission('project:update') && managerDialog">
        <Dialog :commonDialog="managerDialog">
          <template v-slot:title>Managers</template>
          <template v-slot:body>
            <v-container class="py-0">
              <v-row>
                <v-col md="12" class="py-0">
                  <v-autocomplete
                    dense
                    color="cyan"
                    filled
                    :items="managerList"
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    v-model.trim="managers"
                    label="Managers"
                    solo
                    flat
                    item-color="cyan"
                    item-text="full_name"
                    item-value="id"
                    hide-details
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 3">
                        <span>{{ item.full_name }}</span>
                      </v-chip>
                      <span v-if="index === 3" class="grey--text font-size-12">
                        <template v-if="managers && managers.length"
                          >(+{{ managers.length - 3 }} others)</template
                        >
                      </span>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No Member Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template v-slot:action>
            <v-container class="py-0">
              <v-row>
                <v-col md="12" class="text-right">
                  <v-btn
                    depressed
                    v-on:click="managerDialog = false"
                    :disabled="pageLoading"
                    class="mx-2 custom-grey-border custom-bold-button"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    depressed
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    class="mx-2 custom-bold-button white--text"
                    v-on:click="updateManagers"
                    color="cyan"
                  >
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </Dialog>
      </template>

      <template v-if="getPermission('project:delete') && deleteManagerDialog">
        <MemberDelete :deleteDialog="deleteManagerDialog">
          <template v-slot:title>Delete Confirmation</template>
          <template v-slot:text>
            <h3 class="font-size-16 font-weight-500 delete-text">
              Once you delete
              <span class="font-weight-700">{{ deleteDetail.full_name }}</span
              >, you won't be able to retrieve this later. Are you sure you want
              to delete
              <span class="font-weight-700">{{ deleteDetail.full_name }}</span>
              ?
            </h3>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              :disabled="deleteLoading"
              :loading="deleteLoading"
              class="mx-2 custom-bold-button white--text"
              color="red lighten-1"
              v-on:click="deleteMangerConfirm"
            >
              Yes, Delete it
            </v-btn>

            <v-btn
              depressed
              :disabled="deleteLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="deleteManagerDialog = false"
            >
              No, Keep it
            </v-btn>
          </template>
        </MemberDelete>
      </template>

      <template v-if="getPermission('project:delete') && deleteMemberDialog">
        <MemberDelete :deleteDialog="deleteMemberDialog">
          <template v-slot:title>Delete Confirmation</template>
          <template v-slot:text>
            <h3 class="font-size-16 font-weight-500 delete-text">
              Once you delete
              <span class="font-weight-700">{{ deleteDetail.full_name }}</span
              >, you won't be able to retrieve this later. Are you sure you want
              to delete
              <span class="font-weight-700">{{ deleteDetail.full_name }}</span>
              ?
            </h3>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              :disabled="deleteLoading"
              :loading="deleteLoading"
              class="mx-2 custom-bold-button white--text"
              color="red lighten-1"
              v-on:click="deleteMemberConfirm"
            >
              Yes, Delete it
            </v-btn>

            <v-btn
              depressed
              :disabled="deleteLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="deleteMemberDialog = false"
            >
              No, Keep it
            </v-btn>
          </template>
        </MemberDelete>
      </template>
      <SendMail
        :mail-dialog="mail_dialog"
        title="Send as Email"
        type="project"
        v-on:close="mail_dialog = false"
        :type-id="project"
        :pdf="projectArr?.pdf_url"
        v-on:success="getProject()"
      ></SendMail>
    </template>
    <template v-slot:footer> </template>
  </DetailTemplate>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET, PATCH, DELETE } from "@/core/services/store/request.module";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import Tasks from "@/view/pages/partials/Detail/Tasks";
import Milestones from "@/view/pages/partials/Detail/Milestones";
/* import Attachments from "@/view/pages/partials/Detail/Attachments"; */
import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";
import Timesheets from "@/view/pages/partials/Detail/Timesheets";
import Tickets from "@/view/pages/partials/Detail/Tickets";
import Quotations from "@/view/pages/partials/Detail/Quotation";
import ProjectCostings from "@/view/pages/partials/Detail/ProjectCosting";
import PurchaseOrders from "@/view/pages/partials/Detail/PurchaseOrder";
import Contracts from "@/view/pages/partials/Detail/Contract";
import Invoices from "@/view/pages/partials/Detail/Invoice";
import VisitListingTemplate from "@/view/pages/visit/Visit-Listing-Template";
import ProjectLineItem from "@/view/components/ProjectLineItem.vue";
import JwtService from "@/core/services/jwt.service";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import MemberDelete from "@/view/pages/partials/Delete.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import DatePicker from "@/view/components/QDatePicker.vue";
import SendMail from "@/view/pages/partials/Send-Mail";

export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "project-detail",
  title: "Project",
  data() {
    return {
      mail_dialog: false,
      projectTab: "property",
      poEditMode: false,
      memberDialog: false,
      deleteDetail: new Object(),
      deleteMemberDialog: false,
      deleteManagerDialog: false,
      members: [],
      memberList: [],
      managers: [],
      managerList: [],
      managerDialog: false,
      project: 0,
      pageLoading: true,
      projectArr: {},
      fileArr: [],
      tabs: [
        {
          title: "Overview",
          icon: "mdi-phone",
          key: "property",
          disabled: false,
        },
        {
          title: "Milestones",
          icon: "mdi-phone",
          key: "milestones",
          disabled: false,
        },
        /*   {
          title: "Visit",
          icon: "mdi-credit-card",
          key: "visit",
          disabled: false,
        }, */

        {
          title: "Line Items",
          icon: "mdi-credit-card",
          key: "line-item",
          disabled: false,
        },

        {
          title: "Attachments",
          icon: "mdi-credit-card",
          key: "attachment",
          disabled: false,
        },
        /* {
          title: "Tasks",
          icon: "mdi-credit-card",
          key: "task",
          disabled: false,
        },
        {
          title: "Timesheets",
          icon: "mdi-credit-card",
          key: "timesheet",
          disabled: false,
        },
        
         {
          title: "Jobs",
          icon: "mdi-credit-card",
          key: "job",
          disabled: false,
        } ,
        
        {
          title: "Project Costings",
          icon: "mdi-credit-card",
          key: "costing",
          disabled: false,
        },
        {
          title: "Quotations",
          icon: "mdi-account-multiple",
          key: "quotation",
          disabled: false,
        },
        {
          title: "Purchase Orders",
          icon: "mdi-account-multiple",
          key: "purchase-order",
          disabled: false,
        },
        {
          title: "Contracts",
          icon: "mdi-account-multiple",
          key: "contract",
          disabled: false,
        },
        {
          title: "Invoices",
          icon: "mdi-account-multiple",
          key: "invoice",
          disabled: false,
        }, */
        {
          title: "History",
          icon: "mdi-credit-card",
          key: "history",
          disabled: false,
        },
      ],
      projectMoreAction: [],
      download_template: "HYC_Pn_Inst",
    };
  },
  components: {
    Milestones,
    Tasks,
    /*  Attachments, */
    AdditionalDocuments,
    Tickets,
    Contracts,
    Invoices,
    Quotations,
    PurchaseOrders,
    Timesheets,
    DetailTemplate,
    CustomStatus,
    ProjectCostings,
    InternalHistoryDetail,
    VisitListingTemplate,
    ProjectLineItem,
    MemberDelete,
    Dialog,
    "date-picker": DatePicker,
    SendMail,
  },
  watch: {
    "projectArr.members"(members) {
      if (members && members.length > 0) {
        this.members = members.map((row) => {
          return row?.user?.id;
        });
      }
    },
    "projectArr.managers"(managers) {
      if (managers && managers.length > 0) {
        this.managers = managers.map((row) => {
          return row?.user?.id;
        });
      }
    },
  },
  methods: {
    getRename(text) {
      switch (text) {
        case "weekly":
          return "Weeks";

        case "monthly":
          return "Months";

        case "bi-monthly":
          return "Bi-Month";

        case "quarterly":
          return "Quarter";

        case "yearly":
          return "Years";

        default:
          return text;
      }
    },

    deleteMember(member) {
      this.deleteDetail = member;
      this.deleteMemberDialog = true;
    },
    deleteMemberConfirm() {
      const _this = this;
      _this.deleteLoading = true;
      _this.$store
        .dispatch(DELETE, {
          url:
            "project/" + _this.project + "/members/" + _this.deleteDetail?.id,
        })
        .then(() => {
          _this.deleteDetail = new Object();
          _this.deleteMemberDialog = false;
          _this.getProject();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.deleteLoading = false;
        });
    },
    deleteManager(member) {
      this.deleteDetail = member;
      this.deleteManagerDialog = true;
    },
    deleteMangerConfirm() {
      const _this = this;
      _this.deleteLoading = true;
      _this.$store
        .dispatch(DELETE, {
          url:
            "project/" + _this.project + "/managers/" + _this.deleteDetail?.id,
        })
        .then(() => {
          _this.deleteDetail = new Object();
          _this.deleteManagerDialog = false;
          _this.getProject();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.deleteLoading = false;
        });
    },
    updateMembers() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "project/" + _this.project + "/members",
          data: { members: _this.members },
        })
        .then(() => {
          _this.memberDialog = false;
          _this.getProject();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    updateManagers() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "project/" + _this.project + "/managers",
          data: { managers: _this.managers },
        })
        .then(() => {
          _this.managerDialog = false;
          _this.getProject();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    getMembers() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "project/members",
        })
        .then(({ data }) => {
          _this.memberList = data;
          _this.managerList = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    lengthCount(param) {
      this.itemCount = param;
    },
    updateProject() {
      let _this = this;
      _this.$router.push(
        _this.getDefaultRoute("project.update", {
          params: {
            id: _this.projectArr && _this.projectArr ? _this.projectArr?.id : 0,
          },
          query: {
            customer: _this.lodash.toSafeInteger(
              _this.projectArr?.customer?.id
            ),
            property: _this.lodash.toSafeInteger(
              _this.projectArr?.property?.id
            ),
          },
        })
      );
    },
    refressData() {
      this.getProject();
      this.getFile();
    },

    getStatus(status) {
      if (status == 1) {
        return "Not Started";
      } else if (status == 2) {
        return "In Progress";
      } else if (status == 3) {
        return "On Hold";
      } else if (status == 4) {
        return "Cancelled";
      } else if (status == 5) {
        return "Finished";
      }
    },
    getColor(status) {
      if (status == 1) {
        return "blue white--text";
      } else if (status == 2) {
        return "purple white--text";
      } else if (status == 3) {
        return "orange white--text";
      } else if (status == 4) {
        return "red white--text";
      } else if (status == 5) {
        return "green white--text";
      }
    },

    downloadPDFNew() {
      const { id } = this.projectArr;
      const token = JwtService.getToken();
      const url = `${this.$apiURL}project/${id}/pdf/download/${this.download_template}?token=${token}`;
      window.open(url, "_blank");
    },

    updateMoreAction(action) {
      const _this = this;
      switch (action) {
        case "duplicate":
          _this.$router.push(
            _this.getDefaultRoute("project.create", {
              query: {
                duplicate: _this.projectArr.id,
                customer: _this.lodash.toSafeInteger(
                  _this.projectArr.customer.id
                ),
                property: _this.lodash.toSafeInteger(
                  _this.projectArr.property_relation.id
                ),
              },
            })
          );
          break;
        case "edit":
          _this.$router.push(
            _this.getDefaultRoute("project.update", {
              params: {
                id: _this.projectArr.id,
              },
              query: {
                customer: _this.lodash.toSafeInteger(
                  _this.projectArr.customer.id
                ),
                property: _this.lodash.toSafeInteger(
                  _this.projectArr?.property_relation?.id
                ),
              },
            })
          );
          break;
        case "mark_as_inprogress":
          _this.updateProjectStatus(2);
          break;
        case "mark_as_hold":
          _this.updateProjectStatus(3);
          break;
        case "mark_as_cancel":
          _this.updateProjectStatus(4);
          break;
        case "mark_as_finish":
          _this.updateProjectStatus(5);
          break;
        case "download_pdf":
          _this.downloadPDFNew();
          break;
        case "print":
          break;
        case "send_as_email":
          this.mail_dialog = true;
          break;
      }
    },
    updateProjectStatus(status) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "project/" + _this.project + "/status",
          data: { status: status, date: this.projectArr?.date },
        })
        .then(() => {
          _this.getProject();
          _this.poEditMode = false;
        })
        .catch((error) => {
          _this.pageLoading = false;
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    getProject() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "projects/" + _this.project,
        })
        .then(({ data }) => {
          _this.projectArr = data;
          _this.projectMoreAction = data.more_actions;
        })
        .catch((error) => {
          _this.logError(error);
          _this.goBack();
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    getFile() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "project-file/" + _this.project,
        })
        .then(({ data }) => {
          _this.fileArr = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    const _this = this;
    _this.getProject();
    if (this.project > 0) {
      _this.getFile();
    }
    _this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Project",
        route: "project",
      },
      {
        title: "Detail",
      },
    ]);
    this.getMembers();
  },
  created() {
    const _this = this;
    _this.project = _this.lodash.toSafeInteger(_this.$route.params.id);
    if (!_this.project || _this.project <= 0) {
      _this.$router.go(-1);
    }

    if (_this.$route.query && _this.$route.query.tab) {
      _this.projectTab = _this.$route.query.tab;
    }
  },
  computed: {
    getPageTitle() {
      let result = [];
      if (this.lodash.isEmpty(this.projectArr) === false) {
        if (this.projectArr.name) {
          result.push(this.projectArr.name);
        }
        if (this.projectArr.barcode) {
          result.push(this.projectArr.barcode);
        }
      }
      return result.join(" • ");
    },
    /* projectTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        if (val != this.projectTab) {
          this.$router.push({ query });
        }
      },
      get() {
        return this.$route.query.tab || "project";
      },
    },*/
  },
};
</script>
